module.exports = __webpack_public_path__ + "static/img/bg_item1.27adf54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_item1.png
// module id = Zg8h
// module chunks = 19